import Component from './Component';

export default class Toggle extends Component {
	get events() {
		return {
			'click': 'handleClick',
		};
	}

	handleClick(e) {
		e.preventDefault();
		this.el.classList.toggle(this.data.class);
	}
}
